import _arrayBufferIsDetached from "../internals/array-buffer-is-detached";
var exports = {};
var isDetached = _arrayBufferIsDetached;
var $TypeError = TypeError;
exports = function (it) {
  if (isDetached(it)) throw new $TypeError("ArrayBuffer is detached");
  return it;
};
export default exports;